import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import type { MeteringOrMarketLocationSuggestedCommissionPeriodResponse } from "../utils/backend-types";
import { COMPONENT_QUERY_KEY } from "../utils/constants.ts";
import type { ObjectName } from "../utils/enums.ts";

export function useMeteringOrMarketLocationSuggestedCommissionPeriodMutation(
  objectName: ObjectName.MeteringLocation | ObjectName.MarketLocation
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (locationId: number) =>
      mutateMeteringOrMarketLocationWithSuggestedCommissionPeriod(locationId),
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({
          queryKey: [COMPONENT_QUERY_KEY[objectName]]
        })
      ]);
    }
  });
}

async function mutateMeteringOrMarketLocationWithSuggestedCommissionPeriod(
  locationId: number
) {
  const { data: suggestion } =
    await api.get<MeteringOrMarketLocationSuggestedCommissionPeriodResponse>(
      urls.api.meteringOrMarketLocationsSuggestedCommissionPeriod(locationId)
    );

  const patchUrl = urls.api.meteringOrMarketLocation(locationId);
  return api.patch(patchUrl, {
    commissioning: suggestion.commissioning,
    decommissioning: suggestion.decommissioning
  });
}
